import { Color, Themes } from "@glossy";
import { getDarkTheme, getLightTheme } from "@glossy/theme/templates";
import { getLightThemes } from "@glossy/theme/templates/light";

export const getDarkThemes = (): Themes => ({
  surface: getLightTheme(),
  header: getLightThemes().header,
  body: getDarkTheme(),
  tile: getDarkTheme({ background: Color.BlackRock }),
  edition: getLightThemes().edition,
});
